<ng-container>
	<div data-test-id="ps-error-modal-wrapper" class="wrapper d-flex flex-column align-items-center h-100 w-100">
		<h2 data-test-id="ps-error-modal-title" class="title">{{ errorTitle }}</h2>

		<p
			data-test-id="ps-error-modal-text"
			class="text text-center mb-4"
			*ngIf="data !== potentialSavingErrorType.MISSING_PERMISSIONS; else missingPermissionsText"
		>
			{{ errorText }}
		</p>

		<div class="actions_buttons mt-auto d-flex justify-content-center align-items-center">
			<button
				*ngIf="isCloseButtonVisible"
				type="button"
				class="btn btn-cancel mr-2"
				data-test-id="ps-error-modal-cancel-button"
				(click)="closeModal()"
			>
				Cancel
			</button>
			<button type="button" class="btn btn-action" data-test-id="ps-error-modal-action-button" (click)="applyAction()">
				{{ actionButtonText }}
			</button>
		</div>
	</div>
</ng-container>

<ng-template #missingPermissionsText>
	<p data-test-id="ps-error-modal-text" class="text text-center mb-2">
		We're sorry but it looks like you haven't onboarded an account with the correct IAM role attached to enable this
		report. Please onboard an account or update your IAM role to enable this feature.
		<span *ngIf="isSupportFormVisible">
			See detailed explanation at:
			<a [href]="linkToDoc" target="_blank">link</a>
		</span>
	</p>
	<p class="text text-center mb-4">
		If you have done this and still cannot access the report, please contact
		<span>{{ isSupportFormVisible ? 'support' : 'your provider' }}</span
		>.
	</p>
</ng-template>
